import React from "react";
import PropTypes from "prop-types";

const DrawerMenu = ({children}) => (
  <div className={"DrawerMenu-Root"}>
    {children}
  </div>
);

DrawerMenu.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]),
};

export default DrawerMenu;